export default function GoogleSuccess() {
  return (
    <div className="container">
    <div className="card">
      <h2>🎉 Google Calendar Connected</h2>
      <p>You can now add reminders for episodes.</p>
    </div>
  </div>

  );
}
